import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSSR from "../../hooks/useSSR";
import { updatePreference } from "../../actions/Preferences/dispatchers";
import { setBundle } from "../../utils/ups";
import { getCached } from "../../utils/preferences/library";
import {
    DEFAULT_PREFERENCES,
    BUNDLE_ID,
} from "../../constants/userPreferences";

function useUPS() {
    const dispatch = useDispatch();

    const { userId, preferences, isLoading } = useSelector(
        (state) => state.preferences
    );

    const update = (preference, value) => {
        const bundle = { [preference]: value };
        dispatch(updatePreference(userId, preference, value));
        setBundle(userId, BUNDLE_ID, bundle);
    };

    return {
        userId,
        preferences,
        update,
        isLoading,
    };
}

export function usePreference(preference) {
    const { userId, preferences, update, isLoading } = useUPS();

    const isSSR = useSSR();
    const cached = useMemo(() => {
        if (isSSR) {
            return undefined;
        }
        return getCached(preference);
    }, [userId, isSSR]);

    const stored = preferences.hasOwnProperty(preference)
        ? preferences[preference]
        : cached;

    const value =
        stored !== undefined ? stored : DEFAULT_PREFERENCES[preference];

    const updatePreference = useMemo(
        () => (value) => update(preference, value),
        [userId]
    );

    return {
        value,
        update: updatePreference,
        isLoading,
        isExplicitlySet: stored !== undefined,
    };
}
